// extracted by mini-css-extract-plugin
export var box = "_40-1";
export var checkboxRow = "_40-8";
export var checked = "_40-2";
export var descriptionSpacer = "_40-a";
export var disabled = "_40-3";
export var icon = "_40-6";
export var input = "_40-0";
export var labelSpacer = "_40-9";
export var medium = "_40-5";
export var small = "_40-4";
export var text = "_40-7";